export const itemTypes = {
	SKILL: 'skills',
	MODULE: 'modules',
	// COMMAND: 'commands',
};
